import React from "react";
import "../styles/aboutUs.css";
import OurValues from "../images/values.jpg";
import aboutUsImg from "../images/aboutUs.jpg";
import ContactFloat from "./contactFloat";
const aboutUs = () => {
  return (
    <>
      <section className="aboutUsContainer">
        <h1>About Us</h1>
        <div className="aboutUsPara">
          <p id="topPara">
            At Healthcare interAction, we empower individuals and organisations
            to reach their full potential through comprehensive, innovative, and
            impactful learning solutions. Our expertise lies in crafting
            learning experiences that drive growth, enhance skills and foster a
            culture of continuous improvement. Our consulting approach is deeply
            rooted in behavioural science, ensuring that the strategies and
            solutions we recommend are based on proven psychological principles,
            ensuring effective and lasting results.
          </p>
          <img id="topParaImg" src={aboutUsImg} alt="About Us" />
        </div>
        <p>
          Our bespoke training programs are tailored to meet the unique needs of
          your organisation. Whether it's leadership development, technical
          skills enhancement or soft skills training, we design and deliver
          engaging workshops, programmes and digital learning solutions that
          align with your strategic goals. Utilising principles from behavioural
          science, we ensure that our training methods are evidence-based and
          proven to drive real change.
        </p>
        <p>
          Our consultants work closely with you to identify areas for
          improvement and develop strategies to optimise performance. We assist
          in creating a culture that supports growth, innovation, and employee
          engagement, ensuring your organisation is well-equipped to achieve its
          long-term objectives.
        </p>
        <p>
          In today's digital world, flexible learning options are essential and
          our digital learning experiences are engaging, interactive and
          accessible from anywhere, at any time.
        </p>
        <h2>Our Values</h2>
        <img src={OurValues} alt="Our Values" />
      </section>
      <ContactFloat />
      <section className="quote">
        <p>
          <sup>‘‘</sup>
          That session yesterday was phenomenal – nailed it!  The team were
          energised and really bought in to the change initiative. Thank you!
          <sub>’’</sub>
        </p>
      </section>
    </>
  );
};

export default aboutUs;
